import _ from 'lodash';

import utils from './utils';
import utilsNew from './utils-new';
import googleFontsApi from './google/api';
import googleFontVariants from './google/variants';

const EMPTY_VALUE = 0;

const cloneTextElements = (elements) => {
  return elements
    .filter((elm) => {
      return elm.getType() === 'lp-pom-text';
    })
    .map((elm) => {
      return elm.view.e.cloneNode(true);
    });
};

const generateTextWrapperElement = (textElements) => {
  const textContainer = document.createElement('div');
  const firstTextEl = _.first(textElements);
  if (!document.body.contains(firstTextEl)) {
    textContainer.style.display = 'none';
    _.forEach(textElements, (element) => {
      textContainer.appendChild(element);
    });
  }
  const parentElement = document.body.querySelector('.lp-pom-root') || document.body;
  parentElement.appendChild(textContainer);
  return textContainer;
};

const getInUseFontsFromElements = (textElements) => {
  const fontList = _(textElements)
    .map(utilsNew.getComputedFontStyles)
    .filter((fontData) => {
      return googleFontsApi.isGoogleFont(fontData.family);
    })
    .map(googleFontVariants.findFontVariant)
    .value();

  const mergedFontList = utilsNew.mergeFontObjs(fontList);
  const uniqFontWeightList = utilsNew.removeDuplicateWeights(mergedFontList);

  return uniqFontWeightList;
};

const storeTextWebFontsInUse = (page) => {
  const textElements = cloneTextElements(page.elements);

  // The DOM elements of the subpages aren't mounted when out of view so we can't
  // get the computed styles of them without first mounting them to the document
  const textContainer = generateTextWrapperElement(textElements);

  // We're spreading the elements out here rather than when adding them to the wrapped
  // div so they can keep their inheritance from parent elements in the DOM
  const spreadElements = textElements
    .map((element) => {
      return element.querySelectorAll('*');
    })
    .reduce((accumulator, nextArray) => {
      return [...accumulator, ...nextArray];
    }, []);

  const uniqFontWeightList = getInUseFontsFromElements(spreadElements);

  // Clean up wrapper from DOM
  textContainer.remove();

  page.settings.webFontsInUse = uniqFontWeightList;

};

const isWebFont = (font) => {
  return Boolean(utils.findValidFontName(font));
};

const getWebfontFamilies = (fonts) => {
  return _(fonts)
    .filter(isWebFont)
    .map((font) => { return `'${font}${utils.formattedWeights}'`; })
    .value();
};

const generateFontScriptTag = webFonts => {
  if (webFonts.length > EMPTY_VALUE) {
    return `<script>window.ub.page.webFonts = [${webFonts.join(',')}];</script>`;
  } else {
    return '';
  }
};

const getFormStyles = (element) => {
  const model = element.model;
  const labelStyles = model.safeGet('style.label.font');
  const checkboxRadioStyles = model.safeGet('style.cbxlabel.font');

  return [labelStyles, checkboxRadioStyles];
};

const getButtonStyles = (element) => {
  const buttonStyle = element.model.safeGet('style');

  return {
    family: buttonStyle.fontFamily,
    style: buttonStyle.fontStyle,
    weight: buttonStyle.fontWeight,
    textStyles: buttonStyle.textStyles
  };
};

const getFontDataFromElement = (element) => {
  const elType = element.type;

  if (elType === 'lp-pom-form') {
    return getFormStyles(element);
  } else if (elType === 'lp-pom-button') {
    return getButtonStyles(element);
  }
};

const getButtonAndFormWebFonts = (elements) => {
  const validElements = [
    'lp-pom-form',
    'lp-pom-button'
  ];

  return _(elements)
    .filter((el) => {
      return _.contains(validElements, el.type);
    })
    .map(getFontDataFromElement)
    .flatten()
    .filter((fontData) => {
      return googleFontsApi.isGoogleFont(fontData.family);
    })
    .map(googleFontVariants.findFontVariant)
    .value();
};

const getPageDefaultFont = (defaultFont = {}) => {
  const {family, weight} = defaultFont;

  return googleFontsApi.isGoogleFont(family) ? { [family]: [weight] } : {};
};

const oldGenerateFontLoadScriptContent = (fonts) => {
  const webFonts = getWebfontFamilies(utils.generateFontList(fonts));

  return generateFontScriptTag(webFonts);
};

const newGenerateFontLoadScriptContent = ({elements, settings}) => {
  const textFontList = settings.webFontsInUse;
  const buttonAndFormFonts = getButtonAndFormWebFonts(elements);
  const defaultPageFont = getPageDefaultFont(settings.defaultFont);

  const allWebFonts = [...buttonAndFormFonts, textFontList, defaultPageFont];

  const mergedFontList = utilsNew.mergeFontObjs(allWebFonts);
  const formattedWebFonts = utilsNew.formatWebFonts(mergedFontList);

  return generateFontScriptTag(formattedWebFonts);
};

const getWebFontsLinkTag = (fonts) => {
  const href = utils.buildFontList(fonts);

  if (_.isEmpty(href)) {
    return '';
  } else {
    return `<link rel="stylesheet" type="text/css" href="${href}" />`;
  }
};

export default {
  oldGenerateFontLoadScriptContent,
  newGenerateFontLoadScriptContent,
  getWebFontsLinkTag,
  storeTextWebFontsInUse
};



// WEBPACK FOOTER //
// ./src/fonts/font-service/publisher.js